package com.eladfinish.bible.contest.screens.pairMatching.usecases

import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.screens.americanQuestions.model.AmericanQuestionItem
import com.eladfinish.bible.contest.screens.pairMatching.model.PairsTopicItem
import io.github.aakira.napier.Napier

class TransformToMultiChoiceQuestionsUseCase {

    operator fun invoke(data: String): List<AmericanQuestionItem> {
        val result = mutableListOf<AmericanQuestionItem>()
        val pairsTopicItems = data.convertToDataClass<List<PairsTopicItem>>()
        var num = 0

        for (pairsTopicItem in pairsTopicItems) {
            val topic = pairsTopicItem.topic
            val keyTitle = pairsTopicItem.keyTitle
            val valueTitle = pairsTopicItem.valueTitle
            val pairList = pairsTopicItem.pairList
            val isSequence = keyTitle == Constants.SERIAL_NUMBER
            val underline = ": ______"

            for (pairItem in pairList) {
                var question = "[$topic]\n"
                var correctAnswer = pairItem.valueItem

                if (isSequence) {
                    val keyItem = pairItem.keyItem
                    if (keyItem.matches("\\d+".toRegex())) {
                        val number = keyItem.toInt()
                        val prev = pairsTopicItem.previousItemDescription
                        val next = pairsTopicItem.nextItemDescription
                        when (number) {
                            1 -> {
                                question += "$prev: $correctAnswer\n$next$underline".trimIndent()
                                correctAnswer = pairList[number].valueItem
                            }

                            pairList.size -> {
                                question += "$prev$underline\n$next: $correctAnswer".trimIndent()
                                correctAnswer = pairList[pairList.size - 2].valueItem
                            }

                            else -> {
                                question += "$prev: $correctAnswer\n$next$underline".trimIndent()
                                correctAnswer = pairList[number].valueItem
                            }
                        }
                    }
                } else {
                    question += "$keyTitle: ${pairItem.keyItem}\n$valueTitle$underline".trimIndent()
                }

                val otherOptions = pairsTopicItem.getSetOfValues().toMutableList()
                otherOptions.remove(pairItem.valueItem)
                if (isSequence) otherOptions.remove(correctAnswer)
                otherOptions.shuffle()

                val options = mutableListOf(
                    correctAnswer,
                    otherOptions.getOrElse(0) { "" },
                    otherOptions.getOrElse(1) { "" },
                    otherOptions.getOrElse(2) { "" },
                )

                num++
                val item = AmericanQuestionItem(
                    num = num,
                    question = question,
                    options = options,
                    correctOption = correctAnswer,
                )
                Napier.d("pair_questionItem V2: $item")
                result.add(item)
            }
        }
        return result
    }
}
